import React, { useEffect, createElement } from 'react';
interface SEOProps {
  title?: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogUrl?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
}
export function SEO({
  title = 'Brittney Gwynn',
  description = 'Fractional COO, Chief of Staff, and Ops for Founders at capacity and under time pressure.',
  ogTitle = 'Fractional COO, Chief of Staff, and Ops',
  ogDescription = 'Embedded operational leadership for high-growth founders',
  ogImage = 'https://cdn.magicpatterns.com/uploads/oWzTYdTJ7LqLo7FXqaaDdw/0-16_copy.jpg',
  ogUrl = 'https://brittneygwynn.com/',
  twitterTitle = 'Fractional COO, Chief of Staff, and Ops',
  twitterDescription = 'Embedded operational leadership for high-growth founders',
  twitterImage = 'https://cdn.magicpatterns.com/uploads/oWzTYdTJ7LqLo7FXqaaDdw/0-16_copy.jpg'
}: SEOProps) {
  useEffect(() => {
    // Set document title
    document.title = title;
    // Helper function to set or update meta tag
    const setMetaTag = (property: string, content: string, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${property}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, property);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    // Standard meta tags
    setMetaTag('description', description, false);
    // Open Graph tags
    setMetaTag('og:type', 'website');
    setMetaTag('og:site_name', 'Brittney Gwynn');
    setMetaTag('og:title', ogTitle);
    setMetaTag('og:description', ogDescription);
    setMetaTag('og:url', ogUrl);
    setMetaTag('og:image', ogImage);
    setMetaTag('og:image:width', '1200');
    setMetaTag('og:image:height', '630');
    // Twitter Card tags
    setMetaTag('twitter:card', 'summary_large_image', false);
    setMetaTag('twitter:title', twitterTitle, false);
    setMetaTag('twitter:description', twitterDescription, false);
    setMetaTag('twitter:image', twitterImage, false);
  }, [title, description, ogTitle, ogDescription, ogImage, ogUrl, twitterTitle, twitterDescription, twitterImage]);
  return null;
}